import URI from 'urijs';
import {ajaxAuthed, API_BASE, RESULT_LIMIT} from "./common";
import {APIError} from "../common/errors";

export function getUserMulti$({ ids }) {
  if (!ids) throw new APIError('getUserMulti$: no id specified in API call');
  let idsString = ids.map(id => `id=${encodeURIComponent(id)}`).join('&');
  return ajaxAuthed({ url: `${API_BASE}/users?${idsString}`});
}

export function getUserByQuery$({ q, offset }) {
  if (!q) throw new APIError('getUserByQuery$: no query specified in API call');
  let query = URI.buildQuery({ q, offset, limit: RESULT_LIMIT });
  let url = URI.joinPaths(API_BASE, 'users').query(query);
  return ajaxAuthed({ url: url.toString() });
}

export function getUsers$({ offset, id, q }) {
  let query = {
    limit: RESULT_LIMIT,
    offset,
    id,
    q,
  };
  let url = URI.joinPaths(API_BASE, 'users');
  url.query(URI.buildQuery(query));
  return ajaxAuthed({ url: url.toString() });
}

export function getMyDetails$() {
  let url = URI.joinPaths(API_BASE, 'users', 'account');
  return ajaxAuthed({ url: url.toString() });
}

export function getUser$({ userId }) {
  if (!userId) throw new APIError('user id not specified in getUser');
  let url = URI.joinPaths(API_BASE, 'users', userId);
  return ajaxAuthed({ url: url.toString() });
}

export function updateUser$({ userId, user }) {
  if (!userId) throw new APIError('user id not specified in updateUser');
  if (!user) throw new APIError('user record not specified in updateUser');
  let url = URI.joinPaths(API_BASE, 'users', userId);
  return ajaxAuthed({ url: url.toString(), method: 'PUT', body: user, headers: { 'Content-Type': 'application/json'} });
}

export function getAddressBookContacts$({ userId, offset, id }) {
  if (!userId) throw new APIError('user id not specified in getAddressBookContacts');
  let query = {
    limit: RESULT_LIMIT,
    offset,
    id,
  };
  let url = URI.joinPaths(API_BASE, 'users', userId, 'contacts');
  url.query(URI.buildQuery(query));
  return ajaxAuthed({ url: url.toString() });
}

export function getAddressBookContactById$({ userId, contactId }) {
  if (!userId) throw new APIError('user id not specified in getAddressBookContactById');
  if (!contactId) throw new APIError('contact id not specified in getAddressBookContactById');
  let url = URI.joinPaths(API_BASE, 'users', userId, 'contacts', contactId);
  return ajaxAuthed({ url: url.toString() });
}

export function addAddressBookContact$({ userId, contactId }) {
  if (!userId) throw new APIError('user id not specified in addAddressBookContact');
  if (!contactId) throw new APIError('contact id not specified in addAddressBookContact');
  let url = URI.joinPaths(API_BASE, 'users', userId, 'contacts', contactId);
  return ajaxAuthed({ url: url.toString(), method: 'PUT' });
}

export function deleteAddressBookContact$({ userId, contactId }) {
  if (!userId) throw new APIError('user id not specified in deleteAddressBookContact');
  if (!contactId) throw new APIError('contact id not specified in deleteAddressBookContact');
  let url = URI.joinPaths(API_BASE, 'users', userId, 'contacts', contactId);
  return ajaxAuthed({ url: url.toString(), method: 'DELETE' });
}

export function getUserContactLists$({ userId, offset, id }) {
  if (!userId) throw new APIError('user id not specified in getUserContactLists');
  let query = {
    limit: RESULT_LIMIT,
    offset,
    id
  };
  let url = URI.joinPaths(API_BASE, 'users', userId, 'contact-lists');
  url.query(URI.buildQuery(query, true));
  return ajaxAuthed({ url: url.toString() });
}

export function createUserContactList$({ userId, name, description }) {
  if (!userId) throw new APIError('user id not specified in createUserContactList');
  if (!name) throw new APIError('name not specified in createUserContactList');
  let url = URI.joinPaths(API_BASE, 'users', userId, 'contact-lists');
  let body = { name, description };
  return ajaxAuthed({ url: url.toString(), method: 'POST', body, headers: { 'Content-Type': 'application/json'} });
}

export function getUserContactListById$({ userId, contactListId, offset }) {
  if (!userId) throw new APIError('user id not specified in getUserContactListById');
  if (!contactListId) throw new APIError('contact list id not specified in getUserContactListById');
  let query = {
    limit: RESULT_LIMIT,
    offset,
  };
  let url = URI.joinPaths(API_BASE, 'users', userId, 'contact-lists', contactListId);
  return ajaxAuthed({ url: url.toString() });
}

export function updateUserContactList$({ userId, contactListId, details }) {
  if (!userId) throw new APIError('user id not specified in updateUserContactList');
  if (!contactListId) throw new APIError('contact list id not specified in updateUserContactList');
  let url = URI.joinPaths(API_BASE, 'users', userId, 'contact-lists', contactListId);
  return ajaxAuthed({ url: url.toString(), method: 'PUT', body: details, headers: { 'Content-Type': 'application/json'}});
}

export function deleteUserContactList$({ userId, contactListId }) {
  if (!userId) throw new APIError('user id not specified in deleteUserContactList');
  if (!contactListId) throw new APIError('contact list id not specified in deleteUserContactList');
  let url = URI.joinPaths(API_BASE, 'users', userId, 'contact-lists', contactListId);
  return ajaxAuthed({ url: url.toString(), method: 'DELETE' });
}

export function getUserContactListUsers$({ userId, contactListId, id, offset }) {
  if (!userId) throw new APIError('user id not specified in getUserContactListUsers');
  if (!contactListId) throw new APIError('contact list id not specified in getUserContactListUsers');
  let query = {
    limit: RESULT_LIMIT,
    offset,
    id,
  };
  let url = URI.joinPaths(API_BASE, 'users', userId, 'contact-lists', contactListId, 'contacts');
  url.query(URI.buildQuery(query));
  return ajaxAuthed({ url: url.toString() });
}

export function addUserContactListUsers$({ userId, contactListId, contactIds = [] }) {
  if (!userId) throw new APIError('user id not specified in addUserContactListUsers');
  if (!contactListId) throw new APIError('contact list id not specified in addUserContactListUsers');
  let url = URI.joinPaths(API_BASE, 'users', userId, 'contact-lists', contactListId, 'contacts');
  return ajaxAuthed({ url: url.toString(), method: 'POST', body: contactIds, headers: { 'Content-Type': 'application/json'} });
}

export function getUserContactListUserById$({ userId, contactListId, contactId }) {
  if (!userId) throw new APIError('user id not specified in getUserContactListUserById');
  if (!contactListId) throw new APIError('contact list id not specified in getUserContactListUserById');
  if (!contactId) throw new APIError('contact id not specified in getUserContactListUserById');
  let url = URI.joinPaths(API_BASE, 'users', userId, 'contact-lists', contactListId, 'contacts', contactId);
  return ajaxAuthed({ url: url.toString() });
}

export function addUserContactListUser$({ userId, contactListId, contactId }) {
  if (!userId) throw new APIError('user id not specified in addUserContactListUser');
  if (!contactListId) throw new APIError('contact list id not specified in addUserContactListUser');
  if (!contactId) throw new APIError('contact id not specified in addUserContactListUser');
  let url = URI.joinPaths(API_BASE, 'users', userId, 'contact-lists', contactListId, 'contacts', contactId);
  return ajaxAuthed({ url: url.toString(), method: 'PUT' });
}

export function deleteUserContactListUser$({ userId, contactListId, contactId }) {
  if (!userId) throw new APIError('user id not specified in deleteUserContactListUser');
  if (!contactListId) throw new APIError('contact list id not specified in deleteUserContactListUser');
  if (!contactId) throw new APIError('contact id not specified in deleteUserContactListUser');
  let url = URI.joinPaths(API_BASE, 'users', userId, 'contact-lists', contactListId, 'contacts', contactId);
  return ajaxAuthed({ url: url.toString(), method: 'DELETE' });
}

export function getMyCompanyJoinRequests$({}) {
  let url = URI.joinPaths(API_BASE, 'users', 'account', 'requests');
  return ajaxAuthed({ url: url.toString(), method: 'GET' });
}

export function addUserContactListEmails$({ userId, contactListId, addresses }) {
  if (!userId) throw new APIError('user id not specified in addUserContactListEmails');
  if (!contactListId) throw new APIError('contact list id not specified in addUserContactListEmails');
  if (!addresses) throw new APIError('addresses not specified in addUserContactListEmails');
  let url = URI.joinPaths(API_BASE, 'users', userId, 'contact-lists', contactListId, 'contacts', 'emails');
  return ajaxAuthed({ url: url.toString(), method: 'POST', body: addresses, headers: { 'Content-Type': 'application/json'}});
}

export function updateMyProfile$({ profile }) {
  if (!profile) throw new APIError('user profile object specified in updateMyProfile');
  let url = URI.joinPaths(API_BASE, 'users', 'account');
  return ajaxAuthed({ url: url.toString(), method: 'PUT', body: profile, headers: { 'Content-Type': 'application/json'}});
}



// WEBPACK FOOTER //
// ./src/services/users.js